import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequest,
  postRequest,
  deleteRequest
} from "../../services";
import {
  decryptMessage, encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getAllPiles = createAsyncThunk(
  "PILES/getAllPiles",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getPilesOverview = createAsyncThunk(
  "PILES/pilesOverview",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getPilesWIPOverview = createAsyncThunk(
  "PILES/pilesWIPOverview",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postUpdatePile = createAsyncThunk(
  "PILES/updatePile",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deletePileData = createAsyncThunk(
  "PILES/deletePile",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getSteelConsumption = createAsyncThunk(
  "PILES/steel-consumption",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getSteelConsumptionById = createAsyncThunk(
  "PILES/steel-consumption/?projectId",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
type SliceState = {
  loading: boolean;
  JwtToken: string;
  loginData: null | "" | Object;
  allPiles: null | "" | Object;
  pilesOverview: null | "" | Object;
  pilesWIPOverview: null | "" | Object;
  updatePile: null | "" | Object;
  deletePile: null | "" | Object;
  steelConsumption: null | "" | Object;
  steelConsumptionById: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  loginData: "",
  allPiles: "",
  pilesOverview: "",
  pilesWIPOverview: "",
  updatePile: "",
  deletePile: "",
  steelConsumption: "",
  steelConsumptionById: ""
};

const pilesSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getAllPiles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllPiles.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allPiles = data?.data;
      } else {
        console.log(data?.status);
        state.allPiles = data?.data;
      }
    });
    builder.addCase(getAllPiles.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getPilesOverview.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPilesOverview.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.pilesOverview = data?.data;
      } else {
        console.log(data?.status);
        state.pilesOverview = data?.data;
      }
    });
    builder.addCase(getPilesOverview.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

     //TODO: Get API CALL START
     builder.addCase(getPilesWIPOverview.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPilesWIPOverview.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.pilesWIPOverview = data?.data;
      } else {
        console.log(data?.status);
        state.pilesWIPOverview = data?.data;
      }
    });
    builder.addCase(getPilesWIPOverview.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Put API CALL START
    builder.addCase(postUpdatePile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postUpdatePile.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.updatePile = data;
      } else {
        data?.message ? toaster("error", data?.message) : toaster("error", data?.errors[0].msg);
        console.log(data?.status);
      }
    });
    builder.addCase(postUpdatePile.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: DEL API CALL START
    builder.addCase(deletePileData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePileData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
          console.log("data", data);
      if (data?.status) {
        toaster("success", data?.message);
        state.deletePile = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(deletePileData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: DEL API CALL END
    //TODO: Get API CALL START
    builder.addCase(getSteelConsumption.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteelConsumption.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.steelConsumption = data?.data;
      } else {
        console.log(data?.status);
        state.steelConsumption = data?.data;
      }
    });
    builder.addCase(getSteelConsumption.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getSteelConsumptionById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteelConsumptionById.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.steelConsumptionById = data?.data;
      } else {
        console.log(data?.status);
        state.steelConsumptionById = data?.data;
      }
    });
    builder.addCase(getSteelConsumptionById.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
  },
});

export const uiActions = pilesSlice.actions;

export default pilesSlice;